import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopBackToOffers = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.BackToOffers), mapTo(actionGameTrackingUpdateShop(IdGameTrackingShopState.BACK_TO_OFFERS)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopBackToOffers.ts
// module id = 1876
// module chunks = 3